import { Action } from '@ngrx/store';
import { ReclamoData, ReclamoTransferData } from 'app/interfaces/reclamos.interface';

export const SET_RECLAMOS = '[reclamos] Set Reclamos';
export const SET_RECLAMOS_DATA = '[reclamos] Set Reclamos Data';
export const SET_NUEVA_BUSQUEDA = '[reclamos] Set Nueva Búsqueda';
export const UNSET_RECLAMOS = '[reclamos] Unset Reclamos';
export const UNSET_RECLAMOS_DATA = '[reclamos] Unset Reclamos Data';
export const UNSET_NUEVA_BUSQUEDA = '[reclamos] Unset Nueva Búsqueda';
export const SET_SINGLE_RECLAMO = '[reclamos] Set Single Prescriptor';

export class SetReclamos implements Action {
    readonly type = SET_RECLAMOS;
    constructor(public reclamoSeteado: any) {}
}

/** Carga en Redux datos necesarios para hacer la búsqueda de reclamos */
export class SetReclamosData implements Action {
    readonly type = SET_RECLAMOS_DATA;
    constructor(public reclamoTransferData: ReclamoTransferData) {}
}

export class SetNuevaBusqueda implements Action {
    readonly type = SET_NUEVA_BUSQUEDA;
    constructor(public nuevaBusqueda: boolean) {}
}

/** Elimina todo lo cargado en Redux en la sección _reclamos-->reclamos_ */
export class UnsetReclamos implements Action {
    readonly type = UNSET_RECLAMOS;
}

/** Elimina todo lo cargado en Redux en la sección _reclamos-->reclamoData_ */
export class UnsetReclamosData implements Action {
    readonly type = UNSET_RECLAMOS_DATA;
}

export class UnsetNuevaBusqueda implements Action {
    readonly type = UNSET_NUEVA_BUSQUEDA;
}

export class SetSingleReclamo implements Action {
    readonly type = SET_SINGLE_RECLAMO;
    constructor(public singleReclamoseteado: any) {}
}

export type ReclamosActions =
    | SetReclamos
    | SetReclamosData
    | SetNuevaBusqueda
    | UnsetReclamos
    | UnsetReclamosData
    | UnsetNuevaBusqueda
    | SetSingleReclamo;
